import { ColDef } from 'ag-grid-community';
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';
import { IMetricsDataModel } from '../../../../../data-models/metrics.data-model';
import { ROUTES } from '../../../../../constants/RouteNameMapping';
import { useCompanyMapLookup } from '../../../../../services/hooks/useSaveCompanyData';
import { FadeInGridWrapper } from '../../../../../components/grid-renderers/FadeInGridWrapper';
import { SimplifiedRoundGrid } from './SimplifiedRoundGrid';
import { SimplifiedOverviewGrid } from './SimplifiedOverviewGrid';
import { ExitDetailsGrid } from './ExitDetailsGrid';

const ModalBox = styled('div')`
  width: 80dvw;
  max-width: 80dvw;
  height: 60dvh;
  max-height: 80dvw;
`;

const ContentWrapper = styled('div')`
  background: ${(props) => props.theme.palette.background.default};
  border-radius: 0.25rem;
  display: grid;
  grid-template-rows: min-content 95px 1fr;
  grid-auto-rows: 95px;
  height: 100%;
  overflow: hidden;
  padding: 1rem;
  row-gap: 2rem;
  width: 100%;
`;

const Header = styled(`div`)`
  column-gap: 1rem;
  display: flex;
  align-items: center;
`;

export interface IRoundsModalContentsProps {
  mainGridColDef: ColDef[];
  mainRowData: IMetricsDataModel;
}
export function RoundsModalContents(props: IRoundsModalContentsProps) {
  const { mainGridColDef, mainRowData } = props;
  const selectedCompanyId = mainRowData.companyId;
  const getCompany = useCompanyMapLookup();
  const company = getCompany(selectedCompanyId);

  function openInNewWindow() {
    window.open(
      `/${ROUTES.FINANCE2}/${ROUTES.FINANCE2_OVERVIEW}/${ROUTES.FINANCE_DETAILS}/${ROUTES.FINANCE_LEDGER}?company=${selectedCompanyId}`
    );
  }

  return (
    <ModalBox>
      <FadeInGridWrapper>
        <ContentWrapper>
          <Header>
            <Typography>Round Tracker</Typography>
            <Button color='secondary' onClick={openInNewWindow}>
              Open In Finance Module
            </Button>
          </Header>
          <SimplifiedOverviewGrid mainGridColDef={mainGridColDef} mainRowData={mainRowData} />
          <SimplifiedRoundGrid selectedCompanyId={selectedCompanyId} />
          {company?.acquirer ? <ExitDetailsGrid company={company} companyMetrics={mainRowData} /> : <></>}
        </ContentWrapper>
      </FadeInGridWrapper>
    </ModalBox>
  );
}
